import React, { useState, useEffect } from "react"
import { Form as AntForm } from "antd"
import PropTypes from "prop-types"

import { ROLES } from "@components/Domain/Constants"
import hasAccess from "@api/hasAccess"
import { CreateModal } from "@components/Page"
import { getFormSchema } from "@components/Form"
import { useAppContext } from "@components/AppContext"
import { useOutletContext } from "react-router-dom"
import useOrganizationName from "@helpers/useOrganizationName"

import useOnSubmit from "./helpers/useOnSubmit"
import getCreateInputs from "./helpers/getCreateInputs"

// NOTE: Revise operations after child funds concept is revised:
const createMemberOperation = "backstage/CreateMember"
const createFundMemberOperation = "backstage/CreateFundMember"

const LABEL_ADD = "Add"
const LABEL_TITLE = `Add [ENTITY]`
const LABEL_STAFF = "Staff"
const LABEL_ADMINISTRATOR = "Administrator"

const getCreateSchema = getFormSchema(createMemberOperation)


const UserCreateModal = ({ modal }) => {
  const [ schema, setSchema ] = useState()

  const [ form ] = AntForm.useForm()

  const { addUser } = useOutletContext()
  const { isConsoleOrganization } = useAppContext()

  const organizationName = useOrganizationName()

  const onSuccess = newUser =>
    addUser(newUser)

  const updateSchema = () => {
    const { roles = [] } = form.getFieldsValue()
    const isAdministrator = roles.includes(ROLES.ADMIN)
    const isApprover = roles.includes(ROLES.APPROVER)
    const shouldShowAccountantPermission = isApprover || isAdministrator

    let createInputs = getCreateInputs(isConsoleOrganization, updateSchema, organizationName)

    if (!shouldShowAccountantPermission) {
      createInputs = createInputs.filter(input => input.name !== "_isAccountant")
    }

    const createSchema = getCreateSchema(createInputs)

    setSchema(createSchema)
  }

  useEffect(() => {
    updateSchema()
  }, [])

  const onSubmit = useOnSubmit()

  const isFund = hasAccess(["fund-users-write"])

  const createOperation = isFund
    ? createFundMemberOperation
    : createMemberOperation

  const entity = isConsoleOrganization
    ? LABEL_ADMINISTRATOR
    : LABEL_STAFF

  const title = LABEL_TITLE
    .replace('[ENTITY]', entity)

  const createModalProps = {
    operation: createOperation,
    submitLabel: LABEL_ADD,
    form,
    modal,
    title,
    entity,
    schema,
    onSubmit,
    onSuccess,
  }

  return (
    <CreateModal {...createModalProps} />
  )
}

UserCreateModal.propTypes = {
  modal: PropTypes.shape({}).isRequired,
}

export default UserCreateModal
